<template>
  <Transition name="fade">
    <div class="vue-modal" v-if="visibility">
      <div class="modal-container">
        <div class="mail-loader" v-if="mailLsLoader">
          <div class="sk-fading-circle">
            <div class="sk-circle sk-circle-1"></div>
            <div class="sk-circle sk-circle-2"></div>
            <div class="sk-circle sk-circle-3"></div>
            <div class="sk-circle sk-circle-4"></div>
            <div class="sk-circle sk-circle-5"></div>
            <div class="sk-circle sk-circle-6"></div>
            <div class="sk-circle sk-circle-7"></div>
            <div class="sk-circle sk-circle-8"></div>
            <div class="sk-circle sk-circle-9"></div>
            <div class="sk-circle sk-circle-10"></div>
            <div class="sk-circle sk-circle-11"></div>
            <div class="sk-circle sk-circle-12"></div>
          </div>
        </div>
        <div class="modal-header">
          <span class="header-name">Forward</span>
          <span class="modal-close" @click.stop="closeForm">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M19.2486 5.03572C19.5415 5.32861 19.5415 5.80348 19.2486 6.09638L13.2032 12.1417L19.2486 18.1871C19.5415 18.48 19.5415 18.9549 19.2486 19.2478C18.9557 19.5407 18.4808 19.5407 18.1879 19.2478L12.1426 13.2024L6.09721 19.2478C5.80432 19.5407 5.32944 19.5407 5.03655 19.2478C4.74366 18.9549 4.74366 18.48 5.03655 18.1871L11.0819 12.1417L5.03655 6.09637C4.74366 5.80348 4.74366 5.32861 5.03655 5.03571C5.32944 4.74282 5.80432 4.74282 6.09721 5.03571L12.1426 11.0811L18.1879 5.03572C18.4808 4.74282 18.9557 4.74282 19.2486 5.03572Z"
                fill="#262626"
              />
            </svg>
          </span>
        </div>
        <div class="modal-content-wrapper">
          <div class="modal-content">
            <div class="input-wrapper input-wrapper__no-edit">
              <span class="name">From:</span>
              <span class="text">{{getAccountEmail}}</span>
            </div>
            <div class="input-wrapper" :class="{error: $v.$dirty && $v.requestData.email_to.$invalid}">
              <span class="name">To:</span>
              <div class="emails-wrapper">
                <div class="email-item" v-for="(email, index) in requestData.email_to" :key="index">
                  <span class="text">{{email}}</span>
                  <button class="del-button" @click.stop="removeEmail('emailTo', email)">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.53549 8.59341L6.94283 6.00076L9.53558 3.40801C9.79573 3.14785 9.79573 2.72542 9.53549 2.46518C9.27533 2.20502 8.8529 2.20502 8.59274 2.46518L6 5.05792L3.40726 2.46518C3.1471 2.20502 2.72467 2.20502 2.46451 2.46518C2.20427 2.72542 2.20427 3.14785 2.46442 3.40801L5.05717 6.00076L2.46451 8.59341C2.20427 8.85366 2.20427 9.27609 2.46442 9.53625C2.72467 9.79649 3.1471 9.79649 3.40734 9.53625L6 6.94359L8.59266 9.53625C8.8529 9.79649 9.27533 9.79649 9.53558 9.53625C9.79573 9.27609 9.79573 8.85366 9.53549 8.59341Z" fill="#2C2C2C"/>
                    </svg>
                  </button>
                </div>
                <div 
                  class="input-item" 
                  contenteditable
                  @keyup="getHelpers($event.target)"
                  @keyup.enter="addEmail('emailTo', $event.target.textContent, $event)"
                  @focus="focusedInput = 'emailTo'"
                ></div>
              </div>
              <div class="helpers-block" v-if="getFilterHelperEmailsTo(searchEmailTo).length != 0 && focusedInput == 'emailTo'">
                <span 
                  class="helpers-block__item" 
                  @click.stop="addEmailByHelper('emailTo', email, $event)"
                  v-for="(email, index) in getFilterHelperEmailsTo(searchEmailTo)" 
                  :key="index" v-html="email">
                </span>
              </div>
              <span class="error-text" v-if="$v.$dirty && !$v.requestData.email_to.required" >Field is required</span>
              <span class="error-text" v-if="$v.$dirty && !$v.requestData.email_to.MycustomEmailValidator" >Wrong email</span>
            </div>
            <div class="input-wrapper" :class="{error: $v.$dirty && $v.requestData.email_to_cc.$invalid}">
              <span class="name">CC:</span>
              <div class="emails-wrapper">
                <div class="email-item" v-for="(email, index) in requestData.email_to_cc" :key="index">
                  <span class="text">{{email}}</span>
                  <button class="del-button" @click.stop="removeEmail('emailToCC', email)">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.53549 8.59341L6.94283 6.00076L9.53558 3.40801C9.79573 3.14785 9.79573 2.72542 9.53549 2.46518C9.27533 2.20502 8.8529 2.20502 8.59274 2.46518L6 5.05792L3.40726 2.46518C3.1471 2.20502 2.72467 2.20502 2.46451 2.46518C2.20427 2.72542 2.20427 3.14785 2.46442 3.40801L5.05717 6.00076L2.46451 8.59341C2.20427 8.85366 2.20427 9.27609 2.46442 9.53625C2.72467 9.79649 3.1471 9.79649 3.40734 9.53625L6 6.94359L8.59266 9.53625C8.8529 9.79649 9.27533 9.79649 9.53558 9.53625C9.79573 9.27609 9.79573 8.85366 9.53549 8.59341Z" fill="#2C2C2C"/>
                    </svg>
                  </button>
                </div>
                <div 
                  class="input-item" 
                  contenteditable
                  @keyup="getHelpers($event.target)"
                  @keyup.enter="addEmail('emailToCC', $event.target.textContent, $event)"
                  @focus="focusedInput = 'emailToCC'"
                ></div>
              </div>
              <div class="helpers-block" v-if="getFilterHelperEmailsTo(searchEmailTo).length != 0 && focusedInput == 'emailToCC'">
                <span 
                  class="helpers-block__item" 
                  @click.stop="addEmailByHelper('emailToCC', email, $event)"
                  v-for="(email, index) in getFilterHelperEmailsTo(searchEmailTo)" 
                  :key="index" v-html="email">
                </span>
              </div>
              <span class="error-text" v-if="$v.$dirty && !$v.requestData.email_to_cc.MycustomEmailValidator" >Wrong email</span>
            </div>
            <div class="input-wrapper" :class="{error: $v.$dirty && $v.requestData.email_to_bcc.$invalid}">
              <span class="name">BCC:</span>
              <div class="emails-wrapper">
                <div class="email-item" v-for="(email, index) in requestData.email_to_bcc" :key="index">
                  <span class="text">{{email}}</span>
                  <button class="del-button" @click.stop="removeEmail('emailToBCC', email)">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.53549 8.59341L6.94283 6.00076L9.53558 3.40801C9.79573 3.14785 9.79573 2.72542 9.53549 2.46518C9.27533 2.20502 8.8529 2.20502 8.59274 2.46518L6 5.05792L3.40726 2.46518C3.1471 2.20502 2.72467 2.20502 2.46451 2.46518C2.20427 2.72542 2.20427 3.14785 2.46442 3.40801L5.05717 6.00076L2.46451 8.59341C2.20427 8.85366 2.20427 9.27609 2.46442 9.53625C2.72467 9.79649 3.1471 9.79649 3.40734 9.53625L6 6.94359L8.59266 9.53625C8.8529 9.79649 9.27533 9.79649 9.53558 9.53625C9.79573 9.27609 9.79573 8.85366 9.53549 8.59341Z" fill="#2C2C2C"/>
                    </svg>
                  </button>
                </div>
                <div 
                  class="input-item" 
                  :contenteditable="true"
                  @keyup="getHelpers($event.target)"
                  @keyup.enter="addEmail('emailToBCC', $event.target.textContent, $event)"
                  @focus="focusedInput = 'emailToBCC'"
                ></div>
              </div>
              <div class="helpers-block" v-if="getFilterHelperEmailsTo(searchEmailTo).length != 0 && focusedInput == 'emailToBCC'">
                <span 
                  class="helpers-block__item" 
                  @click.stop="addEmailByHelper('emailToBCC', email, $event)"
                  v-for="(email, index) in getFilterHelperEmailsTo(searchEmailTo)" 
                  :key="index" v-html="email">
                </span>
              </div>
              <span class="error-text" v-if="$v.$dirty && !$v.requestData.email_to_bcc.MycustomEmailValidator" >Wrong email</span>
            </div>
            <div class="input-wrapper">
              <span class="name">Subject:</span>
              <input type="text" class="text-input" v-model="requestData.subject">
            </div>
            <vue-editor :editorToolbar="customToolbar" class="text-editor" v-model="requestData.text" ></vue-editor>
        
            <ForwardedMessagesList 
              v-if="mailList && mailList.length != 0 && forwardType == 'allInOne'"
              @deleteForwardedItem="deleteForwardedItem($event)"
              :messages="mailList"
              :accordeonName="'replyMessage'"
            ></ForwardedMessagesList>
            <div class="messages-as-files-block" 
              v-if="mailList && mailList.length != 0 && forwardType == 'allInFiles'"
              :class="{'messages-as-files-block_border': getBorder}"
            >
              <div class="email-file-item" v-for="(mail, index) in mailList" :key="mail.id">
                <div class="email-img"></div>
                <span class="email-name">message({{++index}}).eml</span>
                <span class="email-size">{{mail ? mail.size : '0 KB'}}</span>
                <button class="clear-btn" @click="deleteForwardedItem(mail.id)" v-if="mailList.length > 1">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.51424 7.57727C6.21661 7.28258 6.21661 6.80478 6.51424 6.51008C6.81186 6.21539 7.29441 6.21539 7.59204 6.51008L17.4868 16.2961C17.7844 16.5908 17.7844 17.0685 17.4868 17.3632C17.1892 17.6579 16.7066 17.6579 16.409 17.3632L6.51424 7.57727Z" fill="#2C2C2C"/>
                    <path d="M16.4091 6.634C16.7067 6.33931 17.1893 6.33931 17.4869 6.634C17.7845 6.9287 17.7845 7.4065 17.4869 7.70119L7.59214 17.4872C7.29451 17.7819 6.81196 17.7819 6.51434 17.4872C6.21671 17.1925 6.21671 16.7147 6.51434 16.42L16.4091 6.634Z" fill="#2C2C2C"/>
                  </svg>
                </button>
              </div>
            </div>
            <div class="upload-files-block">
              <div class="file-item" v-for="(file, index) in requestData.attachedFiles" :key="index" :class="{loading: !file.id}">
                <div class="file-img"></div>
                <span class="file-name">{{file.file.name}}</span>
                <span class="file-size">{{((file.file.size / 1024).toFixed(2) + ' KB')}}</span>
                <div class="loader-progress-bar">
                  <div class="loader-fill" :style="{width: loadFilesProgress + '%'}"></div>
                </div>
                <button class="clear-btn" @click="removeFile(file.id)">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.51424 7.57727C6.21661 7.28258 6.21661 6.80478 6.51424 6.51008C6.81186 6.21539 7.29441 6.21539 7.59204 6.51008L17.4868 16.2961C17.7844 16.5908 17.7844 17.0685 17.4868 17.3632C17.1892 17.6579 16.7066 17.6579 16.409 17.3632L6.51424 7.57727Z" fill="#2C2C2C"/>
                    <path d="M16.4091 6.634C16.7067 6.33931 17.1893 6.33931 17.4869 6.634C17.7845 6.9287 17.7845 7.4065 17.4869 7.70119L7.59214 17.4872C7.29451 17.7819 6.81196 17.7819 6.51434 17.4872C6.21671 17.1925 6.21671 16.7147 6.51434 16.42L16.4091 6.634Z" fill="#2C2C2C"/>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <label class="white-btn">
            <input type="file" multiple class="file-input" @change="selectFiles($event)">
            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11.9997 21.2348C8.98779 21.2348 6.53809 18.7851 6.53809 15.7733L6.53809 8.12707C6.53809 7.72439 6.86437 7.39891 7.26625 7.39891C7.66827 7.39891 7.99455 7.72439 7.99455 8.12707L7.99455 15.7733C7.99455 17.9812 9.79103 19.7784 11.9997 19.7784C14.2083 19.7784 16.0048 17.9812 16.0048 15.7733V7.76292C16.0048 6.35753 14.8615 5.21428 13.4561 5.21428C12.0506 5.21428 10.9073 6.35753 10.9073 7.76292V15.0451C10.9073 15.6473 11.3974 16.1374 11.9997 16.1374C12.602 16.1374 13.092 15.6473 13.092 15.0451V8.12707C13.092 7.72439 13.4183 7.39891 13.8201 7.39891C14.2222 7.39891 14.5484 7.72439 14.5484 8.12707V15.0451C14.5484 16.4505 13.4051 17.5938 11.9997 17.5938C10.5943 17.5938 9.45088 16.4505 9.45088 15.0451V7.76292C9.45088 5.55509 11.2474 3.75781 13.4561 3.75781C15.6648 3.75781 17.4612 5.55509 17.4612 7.76292V15.7733C17.4612 18.7851 15.0115 21.2348 11.9997 21.2348Z" fill="#094172"/>
            </svg>
            Upload File
          </label>
          <button class="white-btn" @click="saveToDraft">
            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M17.0101 9.5L13.4 5.88995V5.89004L13.3999 5.88994V8.19999C13.3999 8.88853 13.9352 9.45205 14.6123 9.49709C14.6413 9.49902 14.6705 9.5 14.7 9.5H17.0101ZM7.7 3.5C6.20883 3.5 5 4.70883 5 6.2V17.7C5 19.1912 6.20883 20.4 7.7 20.4H16.7C18.1912 20.4 19.4 19.1912 19.4 17.7V9.91005L12.9899 3.5H7.7ZM6.3999 6.19999C6.3999 5.48202 6.98193 4.89999 7.6999 4.89999H11.9999V8.19999C11.9999 9.69116 13.2087 10.9 14.6999 10.9H17.9999V17.7C17.9999 18.418 17.4179 19 16.6999 19H12.8999H11.4999H7.6999C6.98193 19 6.3999 18.418 6.3999 17.7V6.19999Z" fill="#094172"/>
              <path d="M8.59951 13.2C8.59951 12.8134 8.91291 12.5 9.29951 12.5H15.2995C15.6861 12.5 15.9995 12.8134 15.9995 13.2C15.9995 13.5866 15.6861 13.9 15.2995 13.9H9.29951C8.91291 13.9 8.59951 13.5866 8.59951 13.2Z" fill="#094172"/>
              <path d="M8.59951 16.4C8.59951 16.0134 8.91291 15.7 9.29951 15.7H12.2995C12.6861 15.7 12.9995 16.0134 12.9995 16.4C12.9995 16.7866 12.6861 17.1 12.2995 17.1H9.29951C8.91291 17.1 8.59951 16.7866 8.59951 16.4Z" fill="#094172"/>
            </svg>
            Save Draft
          </button>
          <button class="modal-btn" @click="sendEmail">
            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M20.6019 3.84307C20.5122 3.76456 20.403 3.71181 20.2857 3.69041C20.1684 3.66901 20.0476 3.67976 19.9359 3.72153L3.60174 9.78851C3.47527 9.83649 3.36659 9.92216 3.29041 10.0339C3.21424 10.1457 3.17423 10.2782 3.17583 10.4134C3.17742 10.5487 3.22053 10.6802 3.29932 10.7901C3.3781 10.9001 3.48877 10.9832 3.61634 11.0282L10.9375 13.5658L13.4752 20.887C13.5202 21.0146 13.6033 21.1252 13.7132 21.204C13.8232 21.2828 13.9547 21.3259 14.0899 21.3274C14.2252 21.329 14.3577 21.289 14.4694 21.2129C14.5812 21.1367 14.6669 21.028 14.7148 20.9015L20.7818 4.56737C20.8284 4.44258 20.8362 4.30661 20.8041 4.17733C20.772 4.04805 20.7015 3.93156 20.6019 3.84307ZM17.5636 6.00639L11.2827 12.2873L5.78937 10.3816L17.5636 6.00639ZM18.497 6.93978L14.1217 18.7139L12.2161 13.2207L18.497 6.93978Z" fill="white"/>
            </svg>
            Send Message
          </button>
          
        </div>
      </div>
      <WarningModal 
        ref="warningModal"
        :text="'Are you sure you want to delete the draft?'"
        :title="'Delete Draft'"
        :applyText="'Delete and Close'"
        @apply="deleteDraft"
      ></WarningModal>
      <WarningModal 
        ref="warningValidationModal"
        class="no-cancel-button"
        :text="'Select recipients for all emails'"
        :title="'Recipients not selected from all emails'"
        :applyText="'Ok'"
      ></WarningModal>
    </div>
    
  </Transition>
</template>

<script>
  import { VueEditor } from "vue2-editor";
  import { mapGetters, mapActions, mapMutations } from "vuex";
  import { validationMixin } from "vuelidate";
  import { required } from "vuelidate/lib/validators";
  import WarningModal from "@/components/mailbox/WarningModal"
  import ForwardedMessagesList from "@/components/mailbox/ForwardedMessagesList"
  import axios from 'axios'

  const MycustomEmailValidator = (value) => {
    const EMAIL_REGEXP = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu;
    let isValid = true
    if(value){
      value.forEach(element => {
        if(!EMAIL_REGEXP.test(element)) isValid = false
      });
    }
    return isValid
  }
  export default {
    name: 'forwardEmailOne-modal',
    components: {VueEditor, ForwardedMessagesList, WarningModal},
    mixins: [validationMixin],
    props: {
      accounts: {type: Array},
    },
    data: () => ({
      visibility: false,
      mailLsLoader: false,
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ["bold", "italic", "underline", "strike"],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" }
        ],
        ["blockquote", "code-block"],
        [{ color: [] }, { background: [] }],
        ["clean"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ indent: "-1" }, { indent: "+1" }],
      ],
      replyMessagesIds: [],
      mailList: [],
      checkedMail: null,
      focusedInput: '',
      searchEmailTo: '',
      type: 'send', //send, drafts
      savedForm: true,
      requestData: {
        text: '',
        email_to: [],
        email_to_cc: [],
        email_to_bcc: [],
        subject: '',
        attachedFiles: [],
      },
      loadFilesProgress: 0,
      forwardType: 'allInOne'
    }),
    validations(){
      return {
        requestData: {
          email_to: {required, MycustomEmailValidator},
          email_to_cc: {MycustomEmailValidator},
          email_to_bcc: {MycustomEmailValidator},
        }
      }
      
    },
    methods: {
      ...mapActions(["axiosFileAdd", "axiosMailboxCreateEmail", "axiosGetMailboxEmailsByIds"]),
      ...mapMutations(["showLoad", "hideLoad"]),
      showModal(messagesIds, forwardType = 'allInOne'){
        this.forwardType = forwardType
        this.mailLsLoader = true
        this.visibility = true
        this.replyMessagesIds = messagesIds;
        this.fillData(messagesIds)
        .then(() => {
          if(this.getCurrentAccount && this.getCurrentAccount.signature){
            if(this.getCurrentAccount.signature.top_content && this.getCurrentAccount.signature.top_content != ''){
              this.requestData.text = `<p class="signature signature_top">${this.getCurrentAccount.signature.top_content} <strong class="date-text"> ${ new Date().toLocaleString(undefined, {year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hour12: false, minute:'2-digit', second:'2-digit'}) }</strong></p><br><br><br><p class="signature-arrow">--</p><p class="signature" style="white-space: pre-wrap;">${this.getCurrentAccount.signature.content}</p>
              `
            }else{
              this.requestData.text = `<br><br><br><p class="signature-arrow">--</p><p class="signature" style="white-space: pre-wrap;">${this.getCurrentAccount.signature.content}</p>
              `
            }
          }
          this.mailLsLoader = false
          this.unwatch = this.$watch(
            "requestData",
            function () {
              this.savedForm = false;
            },
            { deep: true }
          );
        })
        .catch(err => {
          console.log('err::: ', err);
          this.mailLsLoader = false
          this.$toast.open({
            message: 'Oops! Something went wrong :(',
            type: 'error',
            duration: 3000
          });
        })
        
        
      },
      hideModal(){
        this.visibility = false
        this.$v.$reset()
        this.unwatch()
        this.clearForm()
      },
      fillData(ids){
        return new Promise((resolve, reject) => {
          this.axiosGetMailboxEmailsByIds({ids: ids})
          .then(({data}) => {
            this.mailList = data
            resolve()
          })
          .catch(err => {
            reject(err)
          })
        })
      },
      closeForm(){
        if(this.savedForm){
          this.hideModal()
        }else{
          this.$refs.warningModal.showModal()
        }
      },
      sendEmail(){
        this.$v.$touch();
        if (this.$v.$invalid){
          // this.$refs.warningValidationModal.showModal()
          return false;
        } 
        this.showLoad()
        
        let data = {
          email_from: this.getAccountEmail,
          subject: this.requestData.subject,
          // text: this.getText,
          email_to: this.requestData.email_to,
          email_to_cc: this.requestData.email_to_cc,
          email_to_bcc: this.requestData.email_to_bcc,
          type: this.type,
          files: this.requestData.attachedFiles.map(file => file.id),
        }
        
        // Костыль! Нужно как-то показывать текст введенный в редактор в черновике, но бэкэнд все объединяет в одну кучу
        if(this.type == 'send'){
          data.text = this.getText
        }else{
          data.text = `<strong style="visibility: hidden;" class="draft-text">${this.requestData.text}</strong>`
        }

        if(this.forwardType == 'allInOne'){
          data.forward_messages = this.mailList.map(mail => mail.id)
        }
        if(this.forwardType == 'allInFiles'){
          data.attach_messages = this.mailList.map(mail => mail.message_id)
        }
        this.axiosMailboxCreateEmail(data)
        .then(() => {
          this.hideModal()
          this.hideLoad()
          this.$emit('updateMails')
        })
        .catch(err => {
          console.log('err::: ', err);
          this.hideLoad()
          this.$toast.open({
            message: 'Oops! Something went wrong :(',
            type: 'error',
            duration: 3000
          });
        })
      },
      saveToDraft(){
        this.type = 'drafts'
        this.sendEmail()
      },
      clearForm(){
        this.requestData.text = ''
        this.focusedInput = ''
        this.account = ''
        this.searchEmailTo = ''
        this.requestData.subject = ''
        this.requestData.email_to = []
        this.requestData.email_to_cc = []
        this.requestData.email_to_bcc = []
        this.requestData.attachedFiles = []
        this.type = 'send'
      },
      addEmail(fieldName, email, event = null){
        if(email.trim() == '') return

        if(fieldName == 'emailTo'){
          this.requestData.email_to.push(email)
          // Удалить одинаковые emails
          this.requestData.email_to = [...new Set(this.requestData.email_to)]
        }
        if(fieldName == 'emailToCC'){
          this.requestData.email_to_cc.push(email)
          // Удалить одинаковые emails
          this.requestData.email_to_cc = [...new Set(this.requestData.email_to_cc)]
        }
        if(fieldName == 'emailToBCC'){
          this.requestData.email_to_bcc.push(email)
          // Удалить одинаковые emails
          this.requestData.email_to_bcc = [...new Set(this.requestData.email_to_bcc)]
        }

        if(event) event.target.textContent = ''
        this.searchEmailTo = ''

      },
      removeEmail(fieldName, tagName){
        if(fieldName == 'emailTo'){
          this.requestData.email_to = this.requestData.email_to.filter(tag => tag != tagName)
        }
        if(fieldName == 'emailToCC'){
          this.requestData.email_to_cc = this.requestData.email_to_cc.filter(tag => tag != tagName)
        }
        if(fieldName == 'emailToBCC'){
          this.requestData.email_to_bcc = this.requestData.email_to_bcc.filter(tag => tag != tagName)
        }
        this.searchEmailTo = ''
      },
      getHelpers(e){
        if(this.savedForm) this.savedForm = false
        this.searchEmailTo = e.textContent
      },
      addEmailByHelper(helperName, email, event){
        if(helperName == 'emailTo'){
          event.target.closest('.input-wrapper').querySelector('.input-item').textContent = ''
          this.addEmail('emailTo', email.replace(/<\/?strong>/g, ''))
        }
        if(helperName == 'emailToCC'){
          event.target.closest('.input-wrapper').querySelector('.input-item').textContent = ''
          this.addEmail('emailToCC', email.replace(/<\/?strong>/g, ''))
        }
        if(helperName == 'emailToBCC'){
          event.target.closest('.input-wrapper').querySelector('.input-item').textContent = ''
          this.addEmail('emailToBCC', email.replace(/<\/?strong>/g, ''))
        }
      },
      selectFiles(e){
        e.target.files.forEach(file => {
          let fileData = {
            id: null,
            file: file,
            name: file.name
          }
          this.requestData.attachedFiles.push(fileData)
        })
        this.uploadFiles()
      },
      axiosFileAdd(formData) {
        let that = this;
        return axios.post(process.env.VUE_APP_URL+'/file/', formData, {
          headers: {
            'Authorization': 'token ' + this.getToken,
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: function(progressEvent) {
            that.loadFilesProgress = Math.round( (progressEvent.loaded * 100) / progressEvent.total )
          }
        })
      },
      uploadFiles(){
        this.requestData.attachedFiles.forEach(fileData => {
          if(!fileData.id){
            let data = new FormData();
            data.append("file", fileData.file);
            data.append("name", fileData.name.replace(/(\.[^/.]+$|$)/, `_${this.generateUniqueHash()}$1`));
            this.axiosFileAdd(data)
            .then(({data}) => {
              fileData.id = data.id
              this.loadFilesProgress = 0;
            })
            .catch(err => {
              console.log('err::: ', err);
            })
          }
        })
      },
      removeFile(fileId){
        this.requestData.attachedFiles = this.requestData.attachedFiles.filter(file => file.id != fileId)
      },
      deleteDraft(){
        this.savedForm = true
        this.$toast.open({
          message: 'Draft was not saved!',
          type: 'info',
          duration: 3000
        });
        this.hideModal()
      },
      deleteForwardedItem(messageId){
        this.mailList = this.mailList.filter(mail => mail.id != messageId)
      }
      
    },
    computed: {
      ...mapGetters(["getFilterHelperEmailsTo", "getToken"]),
      getText(){
        let emailTemplate = `
          <!DOCTYPE html>
            <html>
              <head>
                <style>
                  .email-content {
                    max-width: 600px;
                  }
                  .ql-syntax{
                    background: #2C2C2C;
                    color: #F1D36A;
                    padding: 4px;
                    border-radius: 4px;
                    width: fit-content;
                  }
                  .signature{
                    color: #2C2C2C;
                    white-space: pre-wrap;
                  }
                  .signature-arrow{
                    color: #2C2C2C;
                  }
                  blockquote{
                    padding-top: 10px;
                    padding-bottom: 10px;
                    padding-left: 20px;
                    padding-right: 20px;
                    background-color: #F4F6F9;
                    border-top-right-radius: 4px;
                    border-bottom-right-radius: 4px;
                    margin-bottom: 10px;
                    border-left: 3px solid #A3A3A3;
                  }
                  .date-text{
                    font-weight: normal;
                    font-size: 13px;
                    color: #9AA3B0;
                  }
                  
                  ol{
                    padding-left: 16px;
                  }
                  ol li{
                    list-style-type: decimal;
                  }
                  ul{
                    padding-left: 16px;
                  }
                  ul li{
                    list-style-type: disc;
                  }
                  p{
                    white-space: pre-wrap;
                  }
                  .ql-indent-1{
                    padding-left: 10%;
                  }
                  .ql-indent-2{
                    padding-left: 20%;
                  }
                  .ql-indent-3{
                    padding-left: 30%;
                  }
                  .ql-indent-4{
                    padding-left: 40%;
                  }
                  .ql-indent-5{
                    padding-left: 50%;
                  }
                  .ql-indent-6{
                    padding-left: 60%;
                  }
                  .ql-indent-7{
                    padding-left: 70%;
                  }
                  .ql-indent-8{
                    padding-left: 80%;
                  }
                  .ql-align-center{
                    text-align: center;
                  }
                  .ql-align-right{
                    text-align: right;
                  }
                  .ql-align-justify{
                    text-align: justify;
                  }
                </style>
              </head>
              <body>
                <div class="email-content">
                  ${this.requestData.text}
                </div>
              </body>
            </html>
        `
        return emailTemplate
      },
      getCurrentAccount(){
        if(this.replyMessagesIds.length != 0 && this.mailList.length != 0){
          return this.accounts.find(account => account.id == this.mailList[0].account_id)
        }else{
          return null
        }
      },
      getAccountEmail(){
        if(this.replyMessagesIds.length != 0 && this.mailList.length != 0){
          if(this.getCurrentAccount) {
            return this.getCurrentAccount.email
          }else{
            return '-'
          }
        }else{
          return '-'
        }
      },
      getBorder(){
        return this.requestData.attachedFiles.length != 0
      }
    },
  }
</script>

<style lang="scss" scoped>
$spinkit-size: 2em !default;
$spinkit-spinner-color: #319FEF !default;
* {
  box-sizing: border-box;
  // -webkit-touch-callout: text; /* iOS Safari */
  // -webkit-user-select: text; /* Safari */
  // -khtml-user-select: text; /* Konqueror HTML */
  // -moz-user-select: text; /* Firefox */
  // -ms-user-select: text; /* Internet Explorer/Edge */
  // user-select: text; /* Non-prefixed version, currently supported by Chrome and Opera */
}
.quillWrapper{
  /deep/{
    strong{
      font-weight: bold;
      &.date-text{
        font-weight: normal;
        font-size: 13px;
        color: #9AA3B0;
      }
    }
    em{
      font-style: italic;
    }
    // blockquote{
    //   quotes: '«' '»'
    // }
  }
}

.vue-modal {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(38, 38, 38, 0.3);
  top: 0;
  left: 0;
  z-index: 999;
  display: flex;
  // align-items: center;
  justify-content: center;
  padding: 16px;
  overflow-y: auto;

  &:hover {
    cursor: auto;
  }

  .modal-container {
    width: 100%;
    max-width: 1318px;
    background: #ffffff;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    height: fit-content;
  }
}

.modal-header {
  display: flex;
  justify-content: space-between;
  
  border-bottom: 1px solid #DEE3EA;
  padding: 14px 16px;
  .header-name{
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    display: flex;
    align-items: center;
  }
}
.modal-footer{
  display: flex;
  justify-content: flex-end;
  column-gap: 16px;
  // padding: 8px 24px;
  row-gap: 8px;
  border-top: 1px solid #DEE3EA;
  padding: 8px 16px;

  .modal-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    color: var(--color-white);
    background: var(--color-blue);
    transition: .3s;
    // width: 180px;
    width: 200px;
    border-radius: 4px;
    height: 32px;
    // padding: 8px 24px;
    &:hover{
      background: var(--color-blue-dark);
    }
    &.disabled{
      pointer-events: none;
      opacity: .5;
    }
  }
  .white-btn{
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    color: var(--color-blue-dark);
    transition: .3s;
    // padding: 8px 24px;
    height: 32px;
    width: 200px;
    border-radius: 4px;
    border: 1px solid var(--color-blue-dark);
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    *{
      transition: .3s;
    }
    &:hover{
      background: var(--color-blue-dark);
      color: var(--color-white);
      cursor: pointer;
      svg{
        path{
          fill: var(--color-white);
        }
      }
    }
    .file-input{
      opacity: 0;
      position: absolute;
      z-index: -99999;
    }
  }
}
.modal-content-wrapper{
  display: flex;
}
.checked-mails-wrapper{
  border-right: 1px solid var(--color-border);
  width: 320px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  // max-height: 540px;
  .checked-mails-wrapper__heading{
    height: 28px;
    min-height: 28px;
    padding: 0 16px;
    background: var(--color-gray-lightest);
    display: flex;
    align-items: center;
    font-size: 13px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    color: var(--color-new-dark-gray);
    position: sticky;
    top: 0;
  }
  .checked-mail-item{
    height: 28px;
    min-height: 28px;
    display: flex;
    align-items: center;
    padding-left: 16px;
    .email{
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      // line-height: normal;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 100%;
    }
    .del-checked-email{
      display: none;
      align-items: center;
      margin-left: auto;
      &:hover{
        svg{
          path{
            fill: var(--color-blue);
          }
        }
      }
    }
    .error-icn{
      display: flex;
      align-items: center;
      margin-right: 4px;
    }
    &:hover{
      cursor: pointer;
      background: var(--color-gray-lightest);
      .del-checked-email{
        display: flex;
      }
    }
    &.active{
      background: #E5EEFF;
    }
  }
}
.modal-content{
 padding: 16px;
 border: none;
 border-radius: 0;
 display: flex;
 flex-direction: column;
 row-gap: 12px;
//  max-height: 540px;
//  overflow-y: auto;
 flex-grow: 1;
 max-width: 100%;
}
.modal-close {
  &:hover {
    cursor: pointer;
  }
}
.text-editor{
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  /deep/{
    .ql-toolbar{
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
      padding: 0 !important;
      display: flex;
      align-items: center;
      height: 40px;
      column-gap: 16px;
      .ql-formats{
        margin: 0 !important;
      }
    }
    .ql-container{
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
      background: #F4F6F9;
    }
  }
}
.input-wrapper{
  border: none;
  display: flex;
  // height: 38px;
  min-height: 38px;
  align-items: center;
  background: #F4F6F9;
  border: 1px solid #BDCBD6;
  border-radius: 4px;
  position: relative;
  &.error{
    border-color: red;
  }
  
  .text-input{
    height: 100%;
    padding: 0 8px;
    border: none;
  }
  /deep/{
    .multiselect__tags{
      border: none;
    }
  }
  .name{
    padding-left: 9px;
    font-size: 14px;
    font-weight: 400;
    line-height: normal;
    color: #787F89;
  }
  .error-text{
    position: absolute;
    left: 0;
    bottom: -12px;
    font-size: 10px;
    color: red;
  }
  &__no-edit{
    border: none;
    background: none;
    height: auto;
    min-height: 0px;
    min-height: 17px;
    .text{
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      padding-left: 8px;
    }
    .name{
      padding-left: 0px;
    }
  }
  
}
.input-block{
  width: 100%;
  height: 100%;
  position: relative;
}
.helpers-block{
  position: absolute;
  // padding: 6px 0px;
  display: flex;
  flex-direction: column;
  background: var(--color-white);
  width: calc(100% - 40px);
  // row-gap: 6px;
  z-index: 2;
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.8);
  max-height: 200px;
  overflow-y: auto;
  top: 100%;
  .helpers-block__item{
    // color: var(--color-gray-text);
    color: var(--color-dark);
    font-size: 13px;
    transition: .3s;
    min-height: 38px;
    padding: 3px 6px;
    box-sizing: border-box;
    // border: 1px solid red;
    display: flex;
    align-items: center;
    border-bottom: 1px solid var(--color-gray-text);
    /deep/{
      strong{
        font-weight: bold;
        color: var(--color-dark);
      }
    }
    &:last-child{
      border-bottom: none;
    }
    &:hover{
      cursor: pointer;
      color: var(--color-blue-dark);
      transition: .3s;
    }
  }
}

.emails-wrapper{
  padding: 7px;
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  justify-content: flex-start;
  column-gap: 4px;
  row-gap: 4px;
  min-height: 38px;
  flex-grow: 1;
  .email-item{
    display: flex;
    align-items: center;
    column-gap: 2px;
    padding: 2px 8px;
    border-radius: 20px;
    background: var(--color-blue-gray-list);
    align-self: flex-start;
    .text{
      font-size: 13px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
    .del-button{
      width: 12px;
      height: 12px;
      display: flex;
      align-items: center;
      &:hover{
        cursor: pointer;
      }
    }
  }
  .input-item{
    flex-grow: 1;
    display: flex;
    align-items: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    min-height: 16px;
  }
}
.upload-files-block{
  display: flex;
  flex-direction: column;
  row-gap: 14px;
  .file-item{
    display: flex;
    align-items: center;
    column-gap: 8px;
    width: 100%;
    max-width: 640px;
    &.loading{
      .file-name,
      .file-size,
      .file-img{
        opacity: .5;
      }
      .loader-svg{
        display: flex;
      }
      .loader-progress-bar{
        display: flex;
      }
      .clear-btn{
        display: none;
      }
    }
  }
  .clear-btn{
    width: 24px;
    height: 24px;
    min-width: 24px;
    display: flex;
    // margin-left: auto;
    margin-left: 16px;
  }
  .loader-svg{
    margin: 0 auto;
    display: none;
  }
  .loader-progress-bar{
    display: none;
    width: 120px;
    min-width: 120px;
    height: 4px;
    border-radius: 2px;
    background: var(--color-gray-dark);
    margin-left: auto;
    position: relative;
    overflow: hidden;
    .loader-fill{
      position: absolute;
      top: 0;
      left: 0;
      background: var(--color-blue-dark);
      width: 0px;
      height: 100%;
      display: flex;
    }
  }
  .file-name{
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline;
    max-width: 320px;
  }
  .file-size{
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    color: var(--color-gray-text);
    margin-right: auto;
  }
  .file-img{
    background-image: url("data:image/svg+xml,%3Csvg width='40' height='48' viewBox='0 0 40 48' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M3 48H37C38.6569 48 40 46.6569 40 45V13L27 0H3C1.34315 0 0 1.34315 0 3V45C0 46.6569 1.34315 48 3 48Z' fill='%23DEE3EA'/%3E%3Cpath d='M12.9506 31.6148L19.4913 12V28.2712C19.4913 28.5016 19.3571 28.7106 19.1485 28.8052L12.9506 31.6148Z' fill='%239AA3B0'/%3E%3Cpath d='M27.0494 31.6148L20.5087 12V28.2712C20.5087 28.5016 20.6429 28.7106 20.8515 28.8052L27.0494 31.6148Z' fill='%239AA3B0'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M18.6601 17.2724C12.789 17.942 8.22674 22.9613 8.22674 29.0532C8.22674 31.1083 8.74562 33.0403 9.65843 34.7247L19.2353 30.1223V30.9274L9.36213 35.6754L9.19424 35.3854C8.11702 33.525 7.5 31.3611 7.5 29.0532C7.5 22.5847 12.344 17.2562 18.5783 16.5451L18.6601 17.2724ZM31.7733 29.0532C31.7733 22.9613 27.211 17.942 21.3399 17.2724L21.4217 16.5451C27.656 17.2562 32.5 22.5847 32.5 29.0532C32.5 31.3611 31.883 33.525 30.8058 35.3854L30.6359 35.6788L20.7647 30.9412L20.7544 30.1223L30.3435 34.7212C31.2551 33.0376 31.7733 31.1068 31.7733 29.0532Z' fill='%239AA3B0'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M19.2353 33.5294L10.963 37.5732L10.6471 36.9141L19.2353 32.7059V33.5294Z' fill='%239AA3B0'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M19.2353 35.8823L12.6619 39.1399L12.3478 38.4798L19.2353 35.0772V35.8823Z' fill='%239AA3B0'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M19.2353 38.2243L14.2608 40.75L13.9466 40.09L19.2353 37.4192V38.2243Z' fill='%239AA3B0'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M20.7647 33.5294L29.2674 37.5292L29.5833 36.8701L20.7647 32.7059V33.5294Z' fill='%239AA3B0'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M20.7647 35.8823L27.7422 39.1399L28.0562 38.4798L20.7647 35.0772V35.8823Z' fill='%239AA3B0'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M20.7647 38.2243L26.1433 40.75L26.4574 40.09L20.7647 37.4192V38.2243Z' fill='%239AA3B0'/%3E%3Cpath d='M40 13L30 13C28.3431 13 27 11.6569 27 10L27 -1.82822e-07L32.881 5.98L40 13Z' fill='%23BDCBD6'/%3E%3C/svg%3E%0A");
    background-size: cover;
    background-position: center;
    width: 40px;
    height: 48px;
    margin-right: 12px;
  }
}
.messages-as-files-block{
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  max-width: 640px;
  &_border{
    border-bottom: 1px solid var(--color-gray-text);
    padding-bottom: 8px;
    // margin-bottom: 8px;
  }
  .email-file-item{
    display: flex;
    align-items: center;
    column-gap: 8px;
    width: 100%;
    max-width: 640px;
  }
  .clear-btn{
    width: 24px;
    height: 24px;
    min-width: 24px;
    display: flex;
    margin-left: 16px;
  }
  .email-size{
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    color: var(--color-gray-text);
    margin-right: auto;
  }
  .email-img{
    background-image: url("data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M18.6743 20.2014C17.8782 20.7238 16.9534 21 16 21C15.0466 21 14.1219 20.7238 13.3257 20.2014L0.213063 11.1488C0.140313 11.101 0.0694376 11.0512 0 11.0001V25.1004C0 26.717 1.33282 28 2.94582 28H29.0542C30.6966 28 32 26.6881 32 25.1004V11C31.9304 11.0513 31.8594 11.1012 31.7865 11.149L18.6743 20.2014Z' fill='%23DEE3EA'/%3E%3Cpath d='M1.25312 9.45971L14.3658 18.4874C14.8622 18.8292 15.4311 19 15.9999 19C16.5689 19 17.1378 18.8291 17.6342 18.4874L30.7469 9.45971C31.5316 8.91982 32 8.01623 32 7.04101C32 5.36415 30.6789 4 29.0552 4H2.94481C1.32106 4.00006 0 5.36422 0 7.04262C0 8.01623 0.4685 8.91982 1.25312 9.45971Z' fill='%23BDCBD6'/%3E%3C/svg%3E%0A");
    background-size: cover;
    background-position: center;
    width: 40px;
    height: 32px;
    margin-right: 12px;
  }
  .email-name{
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline;
    max-width: 320px;
  }
}
.mail-loader{
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 9;
  background: rgba($color: #fff, $alpha: 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  .sk-fading-circle {
    $circleCount: 12;
    $animationDuration: 1.2s;

    width: $spinkit-size;
    height: $spinkit-size;
    position: relative;
    margin: auto;

    .sk-circle {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
    }

    .sk-circle:before {
      content: '';
      display: block;
      margin: 0 auto;
      width: 15%;
      height: 15%;
      background-color: $spinkit-spinner-color;
      border-radius: 100%;
      animation: sk-fading-circle-delay $animationDuration infinite ease-in-out both;
    }

    @for $i from 2 through $circleCount {
      .sk-circle-#{$i} {
        transform: rotate((360deg / $circleCount * ($i - 1)));
      }
    }

    @for $i from 2 through $circleCount {
      .sk-circle-#{$i}:before {
        animation-delay: (-$animationDuration + $animationDuration / $circleCount * ($i - 1));
      }
    }
  }

  @keyframes sk-fading-circle-delay {
    0%, 39%, 100% {
      opacity: 0;
    }
    40% {
      opacity: 1;
    }
  }
}
.reply-message-text{
  max-width: 600px;
  /deep/{
  strong{
    font-weight: bold;
  }
  em{
    font-style: italic;
  }
  .ql-align-center{
    text-align: center;
  }
  .ql-align-right{
    text-align: right;
  }
  .ql-align-justify{
    text-align: justify;
  }
  blockquote{
    padding: 10px !important;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    background-color: var(--color-white-dark);
    border-left: 3px solid var(--color-gray);
    margin-bottom: 10px;
    margin-top: 10px;
  }
  .ql-syntax, pre{
    background: var(--color-dark);
    color: var(--color-yellow);
    padding: 4px;
    border-radius: 4px;
    width: fit-content;
    margin-bottom: 10px;
    margin-top: 10px;
  }
  ol{
    padding-left: 16px;
    li{
      list-style-type: decimal;
    }
  }
  ul{
    padding-left: 16px;
    li{
      list-style-type: disc;
    }
  }
  p{
    white-space: normal;
  }
  @for $i from 1 to 9{
    $paddingLeft: $i * 10 + '%';
    .ql-indent-#{$i}{
      padding-left: #{$paddingLeft};
    }
  }
  h1{font-size: 2em;}
  h2{font-size: 1.5em;}
  h3{font-size: 1.17em}
  h4{font-size: 1em;}
  h5{font-size: .83em;}
  h6{font-size: .67em;}
  pre{
    max-width: 100%;
    word-wrap: break-word;
    white-space: pre-wrap;
  }
  }
  .text-static{
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    position: relative;
    &::after{
      content: '';
      display: flex;
      position: absolute;
      left: 0;
      width: 100%;
      border-bottom: 1px dashed var(--color-dark);
    }
    &_start{
      margin-bottom: 16px;
    }
    &_end{
      margin-top: 16px;
    }
    span{
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      z-index: 1;
      background: var(--color-white);
      padding: 0 4px;
    }

  }
  .fwd-text_first{
    margin-top: 16px;
  }
  .fwd-text_last{
    margin-bottom: 8px;
  }
}

.max-width-600{
  max-width: 600px;
}


</style>